/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributeWinnerResponse
 */
export interface DistributeWinnerResponse {
    /**
     * true if the winner was distributed by this call; false if the winner was already distributed (idempotent no-op).
     * @type {boolean}
     * @memberof DistributeWinnerResponse
     */
    distributed: boolean;
}

/**
 * Check if a given object implements the DistributeWinnerResponse interface.
 */
export function instanceOfDistributeWinnerResponse(value: object): value is DistributeWinnerResponse {
    if (!('distributed' in value) || value['distributed'] === undefined) return false;
    return true;
}

export function DistributeWinnerResponseFromJSON(json: any): DistributeWinnerResponse {
    return DistributeWinnerResponseFromJSONTyped(json, false);
}

export function DistributeWinnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributeWinnerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'distributed': json['distributed'],
    };
}

export function DistributeWinnerResponseToJSON(json: any): DistributeWinnerResponse {
    return DistributeWinnerResponseToJSONTyped(json, false);
}

export function DistributeWinnerResponseToJSONTyped(value?: DistributeWinnerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'distributed': value['distributed'],
    };
}

